import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.nav `
  --fgColor: ${brand.white};
  --altFgColor: ${brand.white};
  padding: 16px 0;
  background-color: transparent;
  overflow: hidden;
  color: var(--altFgColor);
  
`;
const BreadcrumbList = styled.ul `
  ${siteWide};
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;

  @media (hover: none) {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;
const Breadcrumb = styled.li `
  font-size: 14px;
  line-height: 26px;
  letter-spacing: -0.01em;
  ${fonts.helvetica.bold};
  color: currentColor;

  svg {
    stroke: var(--altFgColor);
    width: 14px;
    height: 14px;
    margin-right: 5px;
    transform: translateY(2px);
  }
`;
const BreadcrumbLink = styled.a `
  color: currentColor;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
const CurrentBreadcrumb = styled.span `
  ${fonts.helvetica.bold};
  color: var(--fgColor);
`;
export const BreadcrumbsStyles = {
    Breadcrumb,
    BreadcrumbLink,
    BreadcrumbList,
    Container,
    CurrentBreadcrumb,
};
